import * as tslib_1 from "tslib";
import { IgrDefinitionBase } from "./igr-definition-base";
import { ColumnMovingSeparator } from "./ColumnMovingSeparator";
var IgrColumnMovingSeparator = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrColumnMovingSeparator, _super);
    function IgrColumnMovingSeparator(props) {
        return _super.call(this, props) || this;
    }
    IgrColumnMovingSeparator.prototype.createImplementation = function () {
        return new ColumnMovingSeparator();
    };
    Object.defineProperty(IgrColumnMovingSeparator.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrColumnMovingSeparator.prototype, "separatorWidth", {
        /**
         * Gets or sets the separator width for this column.
        */
        get: function () {
            return this.i.em;
        },
        set: function (v) {
            this.i.em = +v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrColumnMovingSeparator;
}(IgrDefinitionBase));
export { IgrColumnMovingSeparator };
//# sourceMappingURL=igr-column-moving-separator.js.map
